<template>
  <div class="row">
    <div class="col">
      <card-container
              :title="$router.currentRoute.meta.title"
              :headers="tableHeaders"
              :lastPage="lastPage"
              :totalElements="totalElements"
              :currentPage="getCurrentPage()"
              :clickHandler="pagination">

        <template v-slot:card-header>
          <router-link :to="{ name: `${routePrefix}.create`}" class="btn btn-primary btn-sm"  v-can:add="permissionPrefix">
            <i class="fa fa-plus"></i>
          </router-link>
        </template>

        <template v-slot:card-header-search>
          <search v-model="lastPage" :listHandler="getList"/>
        </template>

        <template v-slot:table-rows>
          <tr v-for="item in items" :key="item.id">
            <td> {{ item.type }} </td>
            <td> {{ item.ownerType }} </td>
            <td> {{ item.ownerId }} </td>
            <td> {{ item.name }} </td>
            <td> {{ item.revenue }} </td>
            <td>
              <input-checkbox v-model="item.enabled" :options="{ id: 'status', onChangeHandler: changeStatus, onChangeParams: { id: item.id, value: !item.enabled }, fullLayout: false, disabled: !can(permissionPrefix,'edit') }"/>
            </td>
            <td class="text-direction-ltr"> {{ item.fromDate | moment("Y-MM-DD hh:mm A") }} </td>
            <td class="text-direction-ltr"> {{ item.toDate | moment("Y-MM-DD hh:mm A") }} </td>
            <td class="">
              <input-checkbox v-model="item.expired" :options="{ id: 'expired', fullLayout: false, disabled: true }"/>
            </td>
            <td class="text-direction-ltr"> {{ item.createdAt | moment("Y-MM-DD hh:mm:ss A")  }} </td>
            <table-item-actions :actions="tableItemActions" :params="{'id':item.id}"/>
          </tr>
          <tr class="text-center" v-if="!items.length">
            <td colspan="999">{{ $t('messages.no_result_found')}}</td>
          </tr>
        </template>
        <template v-slot:card-footer>
          <export-action :crudCode="exportCode" v-can:report="permissionPrefix"></export-action>
        </template>
      </card-container>
    </div>
  </div>
</template>
<script>

  import { mapGetters } from "vuex";
  import { CAPTAIN_BONUSES_LIST as CRUD_ACTION_LIST,CAPTAIN_BONUSES_DELETE as CRUD_ACTION_DELETE, CAPTAIN_BONUSES_UPDATE_STATUS as CRUD_ACTION_UPDATE_STATUS} from 'actions/captain_bonuses';
  import search from "./partials/search";
  const CRUD_CODE="captain_bonuses";
  const CRUD_PERMISSION_CODE=`${CRUD_CODE}`;

  export default {
    name: "CaptainBonusIndex",
    components:{
      search,
    },
    data(){

      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_PERMISSION_CODE,
        exportCode:"captains/bonuses",
        tableHeaders:[
          {
            'title':`fields.type`
          },
          {
            'title':`fields.owner_type`
          },
          {
            'title':`fields.owner_id`
          },
          {
            'title':`fields.name`
          },
          {
            'title':`fields.revenue`
          },
          {
            'title':`fields.enabled`
          },
          {
            'title':`fields.from_date`
          },
          {
            'title':`fields.to_date`
          },
          {
            'title':`fields.expired`
          },
          {
            'title':`fields.created_at`
          },
          {
            'title':`fields.actions`
          }
        ],
        tableItemActions:[
          {
            code:'show',
            route_name:`${CRUD_CODE}.show`,
            can:`${CRUD_PERMISSION_CODE}_can_view`,
          },
          {
            code:'edit',
            route_name:`${CRUD_CODE}.edit`,
            can:`${CRUD_PERMISSION_CODE}_can_edit`,
          },
          {
             code:'logs',
             route_name:`${CRUD_CODE}.logs.index`,
             color_class:`text-dark`,
             icon:`fas fa-list`,
             can:`${CRUD_PERMISSION_CODE}_can_view`,
             title: `${CRUD_CODE}.logs.title`,
          },
          {
            code:'delete',
            can:`${CRUD_PERMISSION_CODE}_can_delete`,
            action:CRUD_ACTION_DELETE,
            successCallback:this.getList
          },
        ],
        items: [],
        perPage:20,
        totalElements:0,
        lastPage:0
      }
    },
    mounted() {
      this.getList();
    },
    computed:{
      ...mapGetters([
        "getSearchFilters","getSearchFiltersIfExists","getSearchFiltersSensitized"
      ])
    },
    methods: {
      getList(){
        this.$store.dispatch(CRUD_ACTION_LIST,{
          pageId: this.getCurrentPage()-1,
          ...this.getSearchFiltersSensitized
        }).then(response=>{
          this.items=response.data.data;
          this.perPage=response.data.perPage;
          this.totalElements=response.data.totalElements;
          this.lastPage=response.data.pageCount;
        })
      },
      pagination(page){
        if(page!== this.getCurrentPage()){
          this.$router.push({
            name: `${this.routePrefix}.index`,
            query:{
              page,
              ...this.getSearchFiltersIfExists
            }
          });
          this.getList();
        }
      },
      getCurrentPage(){
        let currentPage=this.$route.query.page??1;
        return parseInt(currentPage>=1?currentPage:1);
      },
      changeStatus(event, params){
        this.$store.dispatch(CRUD_ACTION_UPDATE_STATUS, {
          id: params.id,
          value:params.value,
          data: {}
        })
        .then(() => {
          swal({
            icon: 'success',
            text: this.$i18n.t("messages.update_successfully"),
            buttons:false,
            timer: 5000
          });
        })
        .catch(error => {
          let message="";
          if(error.response){
            let responseData=error.response.data;

            if(responseData.errors && responseData.errors.error){
              message = responseData.errors.error;
            }
            else{
              message = this.$i18n.t("messages.update_error");
            }
          }
          if(message){
            swal({
              icon: 'error',
              text: message,
              buttons:false,
              timer: 5000
            });
          }
        })
      },
    }
  };
</script>
